import { render, staticRenderFns } from "./FolderView.vue?vue&type=template&id=24f728db&scoped=true&"
import script from "./FolderView.vue?vue&type=script&lang=ts&"
export * from "./FolderView.vue?vue&type=script&lang=ts&"
import style0 from "./FolderView.vue?vue&type=style&index=0&id=24f728db&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f728db",
  null
  
)

export default component.exports